import ShopSalesContainer from './ShopSalesContainer';
export default ShopSalesContainer;
